/**
 * Context key under which the disposition engine reads the case's agent UUID.
 *
 * The engine owns program-flag resolution and derives it SOLELY from this key:
 * `resolveProgramFlag()` looks the (normalized) id up in `AGENT_PROGRAM_FLAGS`, and a
 * missing or unmapped id resolves `false` for every flag — "fail-open". So an engine
 * context without this key silently drops every program-flag-gated required field
 * (`collect_cob`, `enable_afp_question`, `collect_tier_exception`,
 * `collect_rems_certification`, `enable_extended_copay_accumulator_flow`,
 * `advanced_sp_benefits_capture_enabled`).
 *
 * Mirrors `INTERNAL_AGENT_ID_KEY` in
 * `oai-realtime-with-twilio/packages/disposition-engine-js/src/program_flags.ts`
 * (and `constants.INTERNAL_AGENT_ID` in that repo's root). Duplicated here because
 * `@100mslive/disposition-engine` does not export it from its entry point as of
 * 0.19.1 — replace this constant with the package export once it does (BI-1795).
 */
export const INTERNAL_AGENT_ID_KEY = '__internal_agent_id__';
